import React from 'react';
import { PageItem, NavigationPage } from './successlauncher-types';

export interface SubPageProps {
  pageItems: PageItem[];
  onClose: () => void;
  setSelectedPage: (page: NavigationPage) => void;
}

export default function SubPage(props: SubPageProps) {
  return (
    <div className="sub-page">
      {props.pageItems.map((pageItem, i) => (
        <SubPageItem key={i} pageItem={pageItem} onClose={props.onClose} setSelectedPage={props.setSelectedPage} />
      ))}
    </div>
  );
}

export interface SubPageItemProps {
  pageItem: PageItem;
  onClose: () => void;
  setSelectedPage: (page: NavigationPage) => void;
}

function SubPageItem(props: SubPageItemProps) {
  const onClick = () => {
    let shouldClose = true;

    if (props.pageItem.action) {
      shouldClose = props.pageItem.action(props.setSelectedPage);
    }

    if (props.pageItem.link) {
      window.open(props.pageItem.link, '_blank');
    }

    if (shouldClose) {
      props.onClose();
    }
  };

  return (
    <button className="sub-page-item" onClick={onClick}>
      <div className="icon-wrapper">{props.pageItem.icon ? <props.pageItem.icon /> : null}</div>
      <div className="title">{props.pageItem.title}</div>
      <div className="description">{props.pageItem.description}</div>
    </button>
  );
}
